export default __webpack_public_path__ + "static/media/account_icon.a5de0e21.svg";